import React from 'react'
import moment from 'moment'
import GatsbyConfig from '../../../gatsby-config.js'
import { formatPrice } from '../../utils/app-helpers'
import TripSummary from '../partials/trip-summary'
import blossom from '../../../static/images/blossom.png'

const { siteMetadata: config } = GatsbyConfig

export default class Confirmation extends React.Component {
  render() {
    if (typeof window === 'undefined') return <div />
    const { trip, bookData } = this.props
    const tripData = config.trips[trip]
    const roomData = tripData.rooms[bookData.room]
    const payment = bookData.amount - (bookData.discount || 0)
    const lastPayDay = moment(tripData.availabilityCutoff, 'MM-DD-YYYY')
      .subtract({ days: 2 })
      .format('MMMM D, YYYY')

    return (
      <div className="confirmation">
        <div className="wrap">
          <div className="confirmation-room">
            <div
              className="confirmation-room-image"
              style={{ backgroundImage: `url(${roomData.image})` }}
            >
              <img src={blossom} alt="" />
            </div>
            <div className="confirmation-room-details">
              <dl>
                <dt>Hotel</dt>
                <dd>{tripData.venue}</dd>
              </dl>
              <dl>
                <dt>Room Type</dt>
                <dd>{roomData.name}</dd>
              </dl>
              <dl>
                <dt>Check-In</dt>
                <dd>
                  {tripData.checkInDate} @ {tripData.checkInTime}
                </dd>
              </dl>
              <dl>
                <dt>Check-Out</dt>
                <dd>
                  {tripData.checkOutDate} @ {tripData.checkOutTime}
                </dd>
              </dl>
            </div>
          </div>
          <div className="confirmation-plan">
            {bookData.pay === 'monthly' ? (
              <h3>
                {bookData.xMonths} Month Payment Plan | {formatPrice(payment)}/mo
              </h3>
            ) : (
              <h3>Invoice</h3>
            )}
            <TripSummary room={roomData} trip={trip} isPaid />
            <blockquote>
              {bookData.pay === 'monthly' ? (
                <p>
                  * Please note, if your final payment date is after the first
                  day of the trip, your final balance will be processed on{' '}
                  {lastPayDay} to ensure your getaway is paid in full prior to
                  your arrival.
                </p>
              ) : (
                ''
              )}
              <p>
                Everlasting Tours recommends purchasing travel/cancellation
                insurance (must be purchased within 14 days of making your
                reservation).&nbsp;
                <a
                  target="_blank"
                  className="with-icon"
                  href={config.urls.insuranceReferral}
                >
                  <strong>Visit Travel Guard</strong>{' '}
                  <i className="fa fa-external-link" />
                </a>, a travel insurance provider, to find out more about the
                many benefits of travel insurance and to purchase
                travel/cancellation insurance.
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/confirmation.js